module.exports = __webpack_public_path__ + "static/media/settings.04bca2a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/settings.svg
// module id = 1348
// module chunks = 0